import { FlaskSolid, Gift } from 'iconoir-react';

import { UI_SIZE } from '@savgroup-front-common/constants/shared';
import { OrderLineType } from '@savgroup-front-common/types/Product';

import { Tag } from '../../atoms/Tag';
import { TAG_VARIANT } from '../../atoms/Tag/Tag.types';
import { SafeFormattedMessageWithoutSpread } from '../../formatters';

import messages from './messages';

export const OrderLineTypeTag = ({
  orderLineType,
}: {
  orderLineType?: OrderLineType;
}) => {
  return (
    <>
      {orderLineType === OrderLineType.GIFT && (
        <Tag variant={TAG_VARIANT.SUCCESS} size={UI_SIZE.XS} withoutMargin>
          <div className="flex items-center gap-2">
            <Gift width={16} height={16} />
            <SafeFormattedMessageWithoutSpread message={messages.giftTag} />
          </div>
        </Tag>
      )}
      {orderLineType === OrderLineType.SAMPLE && (
        <Tag variant={TAG_VARIANT.DANGER} size={UI_SIZE.XS} withoutMargin>
          <div className="flex items-center gap-2">
            <FlaskSolid width={16} height={16} />
            <SafeFormattedMessageWithoutSpread message={messages.sampleTag} />
          </div>
        </Tag>
      )}
    </>
  );
};
